import { render, staticRenderFns } from "./OtherInfo.vue?vue&type=template&id=75782595&"
import script from "./OtherInfo.vue?vue&type=script&lang=js&"
export * from "./OtherInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports